var map = {
	"./goldcoin/index-btn-home.png": 68350,
	"./memetown/index-btn-home.png": 36285,
	"./reflection/index-btn-home.png": 27885,
	"./tapcoin/index-btn-home.png": 20638
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24380;